module.exports = __webpack_public_path__ + "static/media/loader.6da96bd5.svg";